
import React, { useEffect, useState } from 'react'
import { fifthUrl } from '@services/fifthaveClient'
import { Link } from 'react-router-dom'
import CategoryUtils from "../../common/CategoryUtils"
import PinnedHistoryModal from './PinnedHistoryModal'
import CategoryEditModal from './CategoryEditModal'
import { getFeatureIds } from '@components/search/itemDecorator'
import { searchAttriutes } from '@services/attributeService'

function getAttributeField(product, key: string) {
  const attributes = product?.attributes
  if (attributes 
    && attributes.attributes 
    && attributes.attributes[key]
    && attributes.attributes[key].choices
  ) {
    return attributes.attributes[key].choices
  }
  return null
}

function getAttributeFieldSimpleDisplay(product, key: string) {
  const fields = getAttributeField(product, key)
  return fields ? fields.join(',') : ''
}

function ProductDetailDesSection(props) {
  const { product, refreshProductInfo } = props || {}
  const [pinnedHistoryVisible, setPinnedHistoryVisible] = useState(false)
  const [categoryEditeVisible, setCategoryEditeVisible] = useState(false)
  const [pinnedHistoryType, setPinnedHistoryType] = useState<any>(null)
  const [featureIds, setFeatureIds] = useState<any>(null)
  const categoryCN = CategoryUtils.categoryCNById(product.categoryIds)
  let badges = null
  if (product.badges && product.badges.length) {
    badges = product.badges.map((badge, index) => {
      let className = 'badge'
      if (badge.level === 'SUCCESS') {
        className += ' badge-success'
      } else if (badge.level === 'WARNING') {
        className += ' badge-warning'
      } else if (badge.level === 'ERROR') {
        className += ' badge-error'
      }
      return <span key={index} className={className}>{badge.text}</span>
    })
  }
  const handleHistoryVisible = (show, type) => {
    setPinnedHistoryType(type)
    setPinnedHistoryVisible(show)
  }
  const getPinBrandId = () => {
    return getAttributeFieldSimpleDisplay(product, 'pin_brand_id')
  }
  const getPinCategoryIds = () => {
    return getAttributeFieldSimpleDisplay(product, 'pin_category_ids')
  }
  const getAreaPurchase = () => {
    return getAttributeFieldSimpleDisplay(product, 'area_purchase')
  }
  useEffect(() => {
    const ids = getFeatureIds(product)
    if (!ids?.length) return
    searchAttriutes(ids)
      .then(res => {
        if (Array.isArray(res.data.items)) {
          setFeatureIds(ids.sort().map(id => {
            const item = res.data.items.find(item => item.id === id)
            if (item) {
              return `${item.value}(${item.id})`
            }
            return id
          }))
        } else {
          setFeatureIds(ids)
        }
      })
  }, [product])

  function handleCategoryEdit() {
    setCategoryEditeVisible(true);
  }

  return (
    <dl className="row">
      <dt className="col-sm-4">Brand: </dt>
      <dd className="col-sm-8">
        <span>{product.displayBrand ? product.displayBrand : product.brand} &nbsp;</span>
        <span>{product.brandId ? " | " + product.brandId : ""}</span>
      </dd>
      <dt className="col-sm-4"></dt>
      <dd className="col-sm-8">
        {getPinBrandId() ?
          <a href='javascript:void(0)' onClick={() => handleHistoryVisible(true, 'brand')}>pinned: {getPinBrandId()}</a>
          : null}
      </dd>

      <dt className="col-sm-4">Product ID: </dt>
      <dd className="col-sm-8">
        <span>{product.id} </span>
        <a href={`${fifthUrl}/api/v1/products/${product.id}`} target='_blank_' className="btn btn-link">View Json</a>
      </dd>
      {
        getAreaPurchase() && <>
          <dt className='col-sm-4'>
            <span>{'Area Purchase: '}</span>
          </dt>
          <dd className='col-md-8'>
            {getAreaPurchase()}
          </dd>
        </>
      }
      <dt className="col-sm-4">Category: </dt>
      <dd className="col-sm-8">
        <span>{product.category || product.categoryIds?.join(', ')}</span>
      </dd>
      <dt className="col-sm-4"></dt>
      <dd className="col-sm-8">
        {getPinCategoryIds() ?
          <a href='javascript:void(0)' onClick={() => handleHistoryVisible(true, 'category')}>pinned: {getPinCategoryIds()}</a>
          : null}
      </dd>

      <dt className="col-sm-4">Category CN:</dt>
      <dd className="col-sm-8">
        <span>{categoryCN}</span>
        <div className='oi oi-pencil text-info ml-3 mr-5 edit-pencil' onClick={handleCategoryEdit}></div>
      </dd>

      <dt className="col-sm-4">Labels:</dt>
      <dd className="col-sm-8"><span>{product?.labels?.join(',') || '--'}</span></dd>

      <dt className="col-sm-4">Badges:</dt>
      <dd className="col-sm-8">{badges ? badges : '--'}</dd>

      {
        featureIds?.length ? (
          <>
            <dt className="col-sm-4">Feature ID:</dt>
            <dd className="col-sm-8">{featureIds ? featureIds.join(',') : '--'}</dd>
          </>
        ) : null
      }

      <PinnedHistoryModal
        productId={product.id}
        type={pinnedHistoryType}
        visible={pinnedHistoryVisible}
        onClose={() => setPinnedHistoryVisible(false)}
      />
      <CategoryEditModal
        visible={categoryEditeVisible}
        productId={product.id}
        onClose={() => setCategoryEditeVisible(false)}
        refreshProductInfo={refreshProductInfo}
      />
    </dl>
  )
}

export default ProductDetailDesSection
